import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _construct from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e, { isValidElement as r, createElement as t, Component as o, useRef as n, useState as s, useEffect as c } from "react";
import { transform as l } from "sucrase";

function u() {
  return u = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }, u.apply(this, arguments);
}

var p = function p(e) {
  return l(e, {
    transforms: ["jsx", "typescript", "imports"],
    production: !0
  }).code.substring(13);
},
    i = /^(\s*)(<[^>]*>|function[\(\s]|\(\)[\s=]|class\s)(.*)/,
    d = ["default", "import"],
    a = function a(r, t) {
  var o = t.import,
      n = function (e, r) {
    if (null == e) return {};
    var t,
        o,
        n = {},
        s = Object.keys(e);

    for (o = 0; o < s.length; o++) {
      r.indexOf(t = s[o]) >= 0 || (n[t] = e[t]);
    }

    return n;
  }(t, d),
      s = u({
    React: e,
    require: m(o)
  }, n),
      c = Object.keys(s),
      l = c.map(function (e) {
    return s[e];
  });

  return _construct(Function, _toConsumableArray(c).concat([r])).apply(void 0, _toConsumableArray(l));
},
    f = function f(e) {
  var o = e.code,
      n = e.scope;
  if (!o.trim()) return null;
  var s = {};
  a(p(function (e) {
    return e.replace(i, "$1export default $2$3");
  }(o)), u({
    render: function render(e) {
      s.default = e;
    }
  }, n, {
    exports: s
  }));
  var c = s.default;
  return c ? r(c) ? c : "function" == typeof c ? t(c) : "string" == typeof c ? c : null : null;
},
    m = function m() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (r) {
    if (!e.hasOwnProperty(r)) throw new Error("Module not found: '".concat(r, "'"));
    return e[r];
  };
},
    v = function v(e, r) {
  var t = {};
  return a(p(e), u({}, r, {
    exports: t
  })), t;
};

var h = /*#__PURE__*/function (_o) {
  _inherits(h, _o);

  var _super = _createSuper(h);

  function h() {
    var _this;

    _classCallCheck(this, h);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.state = {
      element: null,
      error: null,
      prevCode: null,
      prevScope: void 0
    };
    return _this;
  }

  _createClass(h, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e, r;
      null == (e = (r = this.props).onRendered) || e.call(r, this.state.error || void 0);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(e, r) {
      return e.code !== this.props.code || e.scope !== this.props.scope || r.error !== this.state.error;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var e, r;
      null == (e = (r = this.props).onRendered) || e.call(r, this.state.error || void 0);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.error ? null : this.state.element;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(e, r) {
      if (r.prevCode === e.code && r.prevScope === e.scope) return null;

      try {
        return {
          element: f(e),
          error: null,
          prevCode: e.code,
          prevScope: e.scope
        };
      } catch (r) {
        return {
          element: null,
          error: r,
          prevCode: e.code,
          prevScope: e.scope
        };
      }
    }
  }, {
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(e) {
      return {
        error: e
      };
    }
  }]);

  return h;
}(o);

var y = function y(_ref) {
  var e = _ref.code,
      r = _ref.scope,
      o = _ref.disableCache;

  var l = n(!0),
      u = n(null),
      _s = s(function () {
    var n = t(h, {
      code: e,
      scope: r,
      onRendered: function onRendered(e) {
        e ? i({
          element: o ? null : u.current,
          error: e.toString()
        }) : u.current = n;
      }
    });
    return {
      element: n,
      error: null
    };
  }),
      _s2 = _slicedToArray(_s, 2),
      p = _s2[0],
      i = _s2[1];

  return c(function () {
    if (l.current) return void (l.current = !1);
    var n = t(h, {
      code: e,
      scope: r,
      onRendered: function onRendered(e) {
        e ? i({
          element: o ? null : u.current,
          error: e.toString()
        }) : u.current = n;
      }
    });
    i({
      element: n,
      error: null
    });
  }, [e, r, o]), p;
};

export { h as Runner, m as createRequire, f as generateElement, v as importCode, y as useRunner };